"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var toastr = require("toastr");
var BaseComponent_1 = require("../../../BaseComponent");
var Toaster = /** @class */ (function (_super) {
    __extends(Toaster, _super);
    function Toaster($view, type, message) {
        var _this = _super.call(this, $view) || this;
        _this.message = message;
        _this.type = type;
        _this.bind();
        return _this;
    }
    Toaster.prototype.bind = function () {
        if (this.type === "error") {
            return toastr.error(this.message);
        }
        return toastr.success(this.message);
    };
    return Toaster;
}(BaseComponent_1.default));
exports.default = Toaster;
